import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
   selector: 'app-booking-modal',
   templateUrl: './booking-modal.component.html',
   styleUrls: ['./booking-modal.component.scss'],
   standalone: false,
})
export class BookingModalComponent {
   constructor(private dialogRef: MatDialogRef<BookingModalComponent>, @Inject(MAT_DIALOG_DATA) public data: { rmName: string }) {}

   close() {
      this.dialogRef.close()
   }
}
